import { render, staticRenderFns } from "./ConfirmPaymentModal.vue?vue&type=template&id=6cb51c9a&"
import script from "./ConfirmPaymentModal.vue?vue&type=script&lang=js&"
export * from "./ConfirmPaymentModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports